"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ViewItem;

var _ListItem2 = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemSecondaryAction2 = _interopRequireDefault(require("@material-ui/core/ListItemSecondaryAction"));

var _IconButton2 = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ListItemText2 = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _EditViewName = _interopRequireDefault(require("./EditViewName"));

var _IconView = _interopRequireDefault(require("./IconView"));

var _styles = _interopRequireDefault(require("./styles"));

var _ViewMenuItem = _interopRequireDefault(require("./ViewMenuItem"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

ViewItem.propTypes = {
  id: _propTypes["default"].string,
  name: _propTypes["default"].string,
  type: _propTypes["default"].string,
  total: _propTypes["default"].number,
  color: _propTypes["default"].string,
  selectedView: _propTypes["default"].objectOf({
    id: _propTypes["default"].string,
    type: _propTypes["default"].string,
    name: _propTypes["default"].string
  }),
  onDelete: _propTypes["default"].func,
  onUpdate: _propTypes["default"].func,
  onDuplicate: _propTypes["default"].func,
  onSelect: _propTypes["default"].func
};

function ViewItem(_ref) {
  var id = _ref.id,
      name = _ref.name,
      type = _ref.type,
      color = _ref.color,
      total = _ref.total,
      onDuplicate = _ref.onDuplicate,
      onDelete = _ref.onDelete,
      onUpdate = _ref.onUpdate,
      onSelect = _ref.onSelect,
      selectedView = _ref.selectedView;
  var classes = (0, _styles["default"])();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showInputView = _useState2[0],
      setShowInputView = _useState2[1];

  var isSelectedView = (0, _react.useMemo)(function () {
    return (selectedView === null || selectedView === void 0 ? void 0 : selectedView.id) === id;
  }, [selectedView, id]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      zIndex: 1
    }
  }, !showInputView && /*#__PURE__*/_react["default"].createElement(_ListItem2["default"], {
    button: true,
    selected: isSelectedView,
    className: classes.listItemView,
    disableGutters: true,
    onClick: function onClick() {
      onSelect(id);
    },
    style: {
      backgroundColor: isSelectedView && color + 12,
      maxWidth: "calc((100vw - 550px)/".concat(total >= 6 ? 6 : total, ")")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/_react["default"].createElement(_IconView["default"], {
    type: type,
    color: color,
    isSelectedView: isSelectedView
  })), /*#__PURE__*/_react["default"].createElement(_ListItemText2["default"], {
    style: {
      marginLeft: 8,
      overFlow: "hidden"
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 600,
      fontSize: 13,
      color: isSelectedView ? color : "#031330",
      width: "100%",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      display: "block"
    }
  }, name)), /*#__PURE__*/_react["default"].createElement(_ListItemSecondaryAction2["default"], {
    style: {
      zIndex: 1000,
      right: 9
    }
  }, /*#__PURE__*/_react["default"].createElement(_IconButton2["default"], {
    className: classes.btnHoverDisable,
    style: {
      height: 20,
      width: 30,
      borderRadius: 4,
      color: isSelectedView ? color : "#031330"
    },
    disableRipple: true
  }, /*#__PURE__*/_react["default"].createElement(_ViewMenuItem["default"], {
    id: id,
    type: type,
    setShowInputView: setShowInputView,
    isSelectedView: isSelectedView,
    showInputView: showInputView,
    color: color,
    onDelete: onDelete,
    onDuplicate: onDuplicate,
    total: total
  })))), showInputView && /*#__PURE__*/_react["default"].createElement(_EditViewName["default"], {
    setShowInputView: setShowInputView,
    name: name,
    id: id,
    type: type,
    onUpdate: onUpdate
  }));
}